import api from 'api';

export const loadChats = api('GET /api/ai-chatbot/chats');

export const loadChat = api('GET /api/ai-chatbot/chat/:id');

export const updateChat = api('PUT /api/ai-chatbot/chat/:id');

export const deleteChat = api('DELETE /api/ai-chatbot/chat/:id');
